module.exports = __webpack_public_path__ + "img/picture.3a13916b.png";